// Runs a callback after the current frame paints, so its layout reads do not force a reflow.
const afterPaint = (callback) => {
	// A hidden tab never paints, so requestAnimationFrame would stall until it is shown.
	if ('hidden' === document.visibilityState) {
		setTimeout(callback, 0);
		return;
	}

	requestAnimationFrame(() => {
		requestAnimationFrame(callback);
	});
};

export default afterPaint;
